import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { cn } from "@/lib/utils";
import { TrendingUp, ShoppingCart, Clock, Star, MessageSquare, Users } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";

const CaseStudyResults = () => {
  const { ref, isVisible } = useScrollAnimation();
  const { t, tObject } = useLanguage();
  const p = "caseStudyBgeh.results";
  const items = tObject<Array<{ metric: string; label: string; description: string }>>(`${p}.items`);
  const icons = [MessageSquare, ShoppingCart, Clock, Star, TrendingUp, Users];
  return (
    <section ref={ref as React.RefObject<HTMLElement>} className="py-16 md:py-24 bg-primary">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className={cn("text-center mb-12 transition-all duration-700", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
            <p className="text-sm font-semibold text-chathero-mint uppercase tracking-wider mb-3">{t(`${p}.badge`)}</p>
            <h2 className="text-2xl md:text-3xl font-bold text-primary-foreground mb-4">{t(`${p}.title`)}</h2>
            <p className="text-lg text-primary-foreground/80 max-w-2xl mx-auto">{t(`${p}.intro`)}</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((result, index) => { const Icon = icons[index] || TrendingUp; return (
              <div key={index} className={cn("bg-primary-foreground/10 rounded-2xl p-6 backdrop-blur-sm border border-primary-foreground/20 transition-all duration-500", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")} style={{ transitionDelay: isVisible ? `${index * 100}ms` : "0ms" }}>
                <div className="w-12 h-12 rounded-xl bg-chathero-mint/20 flex items-center justify-center mb-4"><Icon className="w-6 h-6 text-chathero-mint" /></div>
                <div className="text-3xl font-extrabold text-chathero-mint mb-1">{result.metric}</div>
                <div className="text-sm font-semibold text-primary-foreground mb-2">{result.label}</div>
                <p className="text-xs text-primary-foreground/70 leading-relaxed">{result.description}</p>
              </div>
            ); })}
          </div>
        </div>
      </div>
    </section>
  );
};
export default CaseStudyResults;
